module.exports = __webpack_public_path__ + "img/invoice-de-female-hh.c4adc4a0.png";